export const getStakeColorAndClass = (value: string): string => {
  if (value === "EVEN") {
    return "black special_bet";
  }

  if (value === "ODD") {
    return "red special_bet";
  }

  if (value === "R" || value === "B") {
    return "diamond_bet";
  }

  if (+value === 0) {
    return "blue";
  }

  if (+value % 2 !== 0) {
    return "red";
  }

  return "black";
};

export const carouselNumbers = [10, 20, 1000, 50, 100];

export const wheelNumbers = [0, 5, 12, 3, 10, 1, 8, 9, 2, 7, 6, 11, 4];

export const sumArrayElements = (arr: number[]): number =>
  arr.reduce((a, b) => a + b, 0);
